/**
 * Shape of a freshly registered user.
 *
 * Registration used to write `plan: "free"` — a V2 field for a tier that V3
 * removed. Nothing consumed it correctly afterwards: useStorageQuota reads
 * `userData.plan.tier`, which on a plain string is always undefined, so every
 * new account fell through to the hardcoded 5 GB "Free Beta" fallback instead
 * of showing its real state.
 *
 * A new account has no view yet, so nothing is granted here: the credits pool
 * starts empty and the account-level tier is unset (it only ever means "beta").
 * Storage and credits come from the per-view licenses — every view is born with
 * a free one, created by the onViewCreate trigger.
 */

import type { UserPlanV3 } from "@/types";

export function newUserPlanV3(): UserPlanV3 {
  return {
    stripeCustomerId: null,
    credits: {
      balance: 0,
      bonusGranted: 0,
      purchased: 0,
      consumed: 0,
    },
    autoPayOverage: false,
    overageCreditsAccumulated: 0,
  };
}
